/* Dripology Store — theme interactions */
(function(){
  // nav — condense on scroll + hide-on-scroll-down / reveal-on-scroll-up
  var nav = document.getElementById('nav');
  if (nav) {
    var lastY = 0, navTicking = false;
    function onNavScroll(){
      var y = scrollY;
      nav.classList.toggle('scrolled', y > 24);
      if (y > 200 && y > lastY + 4) nav.classList.add('nav-hidden');
      else if (y < lastY - 4 || y <= 200) nav.classList.remove('nav-hidden');
      lastY = y; navTicking = false;
    }
    addEventListener('scroll', function(){ if (!navTicking){ requestAnimationFrame(onNavScroll); navTicking = true; } }, { passive: true });
  }

  // show desktop "Get a Consult" button only on wide screens
  var consultDesk = document.getElementById('consultDesk');
  function syncConsult(){ if (consultDesk) consultDesk.style.display = innerWidth >= 1100 ? 'inline-block' : 'none'; }
  syncConsult(); addEventListener('resize', syncConsult);

  // full-screen menu — accessible dialog with focus trap
  var menubtn = document.getElementById('menubtn'),
      dropdown = document.getElementById('dropdown'),
      menuclose = document.getElementById('menuclose');
  function setMenu(open){
    if (!dropdown) return;
    dropdown.classList.toggle('open', open);
    dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (menubtn) menubtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open){ var first = dropdown.querySelector('a, button'); if (first) first.focus(); }
    else if (menubtn){ menubtn.focus(); }
  }
  function closeMenu(){ setMenu(false); }
  if (menubtn && dropdown) {
    menubtn.addEventListener('click', function(e){ e.stopPropagation(); setMenu(!dropdown.classList.contains('open')); });
    if (menuclose) menuclose.addEventListener('click', closeMenu);
    document.addEventListener('click', function(e){
      if (dropdown.classList.contains('open') && !dropdown.contains(e.target) && !menubtn.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function(e){
      if (!dropdown.classList.contains('open')) return;
      if (e.key === 'Escape'){ closeMenu(); return; }
      if (e.key === 'Tab'){
        var f = dropdown.querySelectorAll('a[href], button'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
  }

  // desktop nav dropdowns — hover is CSS; this adds click-to-pin + keyboard + outside-click
  (function(){
    var items = [].slice.call(document.querySelectorAll('.navitem'));
    if (!items.length) return;
    function closeAll(except){ items.forEach(function(it){ if (it !== except){ it.classList.remove('open'); var t = it.querySelector('.ntrigger'); if (t) t.setAttribute('aria-expanded','false'); } }); }
    items.forEach(function(it){
      var trig = it.querySelector('.ntrigger'); if (!trig) return;
      trig.addEventListener('click', function(e){ e.stopPropagation();
        var open = !it.classList.contains('open'); closeAll(it);
        it.classList.toggle('open', open); trig.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function(e){ if (!e.target.closest('.navitem')) closeAll(null); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(null); });
  })();

  // scroll reveal — staggered cascade within grids, reduced-motion safe
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target, parent = el.parentNode;
        var sibs = parent ? [].slice.call(parent.children).filter(function(c){ return c.classList.contains('reveal'); }) : [];
        var i = sibs.indexOf(el);
        el.style.transitionDelay = (i > 0 ? Math.min(i, 8) * 70 : 0) + 'ms';
        el.classList.add('in');
        io.unobserve(el);
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
    // SAFETY: reveal anything already in view right away, and never let content stay hidden.
    var revealInView = function(){
      document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight * 1.1 && r.bottom > -60) el.classList.add('in');
      });
    };
    revealInView();
    addEventListener('load', revealInView);
    // absolute fallback: if the observer somehow never fires, don't leave near-viewport content invisible
    setTimeout(function(){
      document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
        if (el.getBoundingClientRect().top < innerHeight * 1.5) el.classList.add('in');
      });
    }, 1400);
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* ============ CART DRAWER (AJAX) ============ */
  var SHIP_THRESHOLD = 0; // free shipping sitewide; set in cents to show a progress goal
  var drawer = document.getElementById('cartDrawer'),
      scrim  = document.getElementById('drawerScrim'),
      cdBody = document.getElementById('cdBody'),
      cdFoot = document.getElementById('cdFoot');
  function money(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/,''); }
  function syncBadge(n){ var b=document.getElementById('cartn'); if(!b) return;
    var grew = n > (parseInt(b.textContent,10)||0);
    b.textContent=n; b.classList.toggle('show', n>0);
    if(grew && !matchMedia('(prefers-reduced-motion: reduce)').matches){ b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); } }
  function openDrawer(){ if(!drawer) return; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    scrim.hidden=false; requestAnimationFrame(function(){ scrim.classList.add('show'); }); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true');
    scrim.classList.remove('show'); document.body.style.overflow=''; setTimeout(function(){ scrim.hidden=true; },420); }
  function renderCart(cart){
    syncBadge(cart.item_count);
    if(!drawer) return;
    var ship=document.getElementById('cdShip');
    if(ship){ if(SHIP_THRESHOLD>0 && cart.total_price<SHIP_THRESHOLD){
        var pct=Math.min(100,Math.round(cart.total_price/SHIP_THRESHOLD*100));
        ship.innerHTML=money(SHIP_THRESHOLD-cart.total_price)+' away from free shipping<div class="bar"><i style="right:'+(100-pct)+'%"></i></div>';
      } else { ship.innerHTML='&#10003; Free U.S. shipping included'; } }
    if(!cart.items.length){ cdBody.innerHTML='<p class="cd-empty">Your cart is empty.</p>'; cdFoot.hidden=true; return; }
    cdFoot.hidden=false; document.getElementById('cdSubtotal').textContent=money(cart.total_price);
    cdBody.innerHTML=cart.items.map(function(it){ return '<div class="cd-item" data-key="'+it.key+'">'+
      '<img src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_128x$1$2'):'')+'" alt="">'+
      '<div><h4>'+it.product_title+'</h4>'+
        '<div class="cd-q"><button data-d="-1" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button data-d="1" aria-label="Increase">+</button></div></div>'+
      '<div style="text-align:right"><div class="cd-price">'+money(it.line_price)+'</div><button class="cd-rm" data-rm>Remove</button></div></div>'; }).join('');
  }
  function fetchCart(open){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderCart(c); if(open) openDrawer(); }).catch(function(){ if(open) openDrawer(); }); }
  function changeLine(key,qty){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart).catch(function(){}); }
  document.addEventListener('submit',function(e){ var f=e.target.closest('form[action*="/cart/add"]'); if(!f||!drawer) return;
    e.preventDefault(); var btn=f.querySelector('[type=submit]'); if(btn){btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json();}).then(function(){ if(btn){btn.disabled=false;} fetchCart(true); })
      .catch(function(){ if(btn){btn.disabled=false;} f.submit(); }); });
  var bag=document.querySelector('.bag'); if(bag && drawer){ bag.addEventListener('click',function(e){ e.preventDefault(); fetchCart(true); }); }
  if(scrim) scrim.addEventListener('click',closeDrawer);
  var cdClose=document.getElementById('cdClose'); if(cdClose) cdClose.addEventListener('click',closeDrawer);
  var cdCont=document.getElementById('cdCont'); if(cdCont) cdCont.addEventListener('click',function(e){e.preventDefault();closeDrawer();});
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });
  if(cdBody) cdBody.addEventListener('click',function(e){
    var row=e.target.closest('.cd-item'); if(!row) return; var key=row.dataset.key;
    var cur=parseInt(row.querySelector('.cd-q span').textContent,10)||0;
    if(e.target.dataset.rm!==undefined) changeLine(key,0);
    else if(e.target.dataset.d) changeLine(key,Math.max(0,cur+parseInt(e.target.dataset.d,10)));
  });
  if(drawer) fetchCart(false); // hydrate badge/state on load

  /* ============ NOTIFY-ME MODAL ============ */
  var nmModal=document.getElementById('notifyModal');
  if(nmModal){
    var nmProduct=document.getElementById('nmProduct'), nmTags=document.getElementById('nmTags');
    function openNotify(name){ if(nmProduct) nmProduct.textContent=name||'this device';
      if(nmTags) nmTags.value='notify-me, store, '+(name||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').slice(0,40);
      nmModal.hidden=false; requestAnimationFrame(function(){ nmModal.classList.add('show'); }); document.body.style.overflow='hidden'; }
    function closeNotify(){ nmModal.classList.remove('show'); document.body.style.overflow=''; setTimeout(function(){ nmModal.hidden=true; },350); }
    document.addEventListener('click',function(e){
      var t=e.target.closest('.notify-btn');
      if(t){ e.preventDefault(); e.stopPropagation(); openNotify(t.dataset.notify); return; }
      if(e.target.id==='nmClose' || e.target===nmModal) closeNotify();
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && nmModal.classList.contains('show')) closeNotify(); });
    if(location.hash==='#contact_posted') openNotify();
  }

  /* ============ ANNOUNCEMENT BAR ============ */
  var topbar=document.getElementById('topbar');
  if(topbar){
    if(sessionStorage.getItem('dripTopbar')==='off'){ topbar.style.display='none'; }
    else { document.body.classList.add('topbar-on'); }
    var tx=document.getElementById('topbarX');
    if(tx) tx.addEventListener('click',function(){ topbar.style.display='none'; document.body.classList.remove('topbar-on'); sessionStorage.setItem('dripTopbar','off'); });
  }

  /* ============ HERO ACCENT INK-SETTLE (one-shot) ============ */
  var heroH1=document.querySelector('.hero h1');
  if(heroH1 && !matchMedia('(prefers-reduced-motion: reduce)').matches){ requestAnimationFrame(function(){ heroH1.classList.add('lit'); }); }
})();

/* ============ LAZY-IMAGE SAFETY NET ============ */
/* Guarantees product/grid images load near the viewport even if native loading="lazy" is finicky. */
(function(){
  function loadNow(i){ i.loading='eager'; if(!i.complete || !i.naturalWidth){ var s=i.currentSrc || i.getAttribute('src'); if(s) i.src=s; } }
  if(!('IntersectionObserver' in window)){
    document.addEventListener('DOMContentLoaded', function(){ document.querySelectorAll('img[loading="lazy"]').forEach(loadNow); });
    return;
  }
  var lio = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ loadNow(e.target); lio.unobserve(e.target); } });
  }, { rootMargin: '800px 0px' });
  function obs(){ document.querySelectorAll('img[loading="lazy"]').forEach(function(i){ lio.observe(i); }); }
  if(document.readyState!=='loading') obs(); else document.addEventListener('DOMContentLoaded', obs);
  // final fallback: once the page settles, force any lazy image that still hasn't painted
  addEventListener('load', function(){ setTimeout(function(){
    document.querySelectorAll('img[loading="lazy"]').forEach(function(i){ if(!i.complete || !i.naturalWidth) loadNow(i); });
  }, 600); });
})();
